<template>
  <div>
    <template v-if="loading">
      <div class="d-flex justify-content-center align-items-center mb-3" style="height: 100%">
        <CSpinner color="custom-color" style="width: 4rem; height: 4rem" />
      </div>
    </template>
    <div v-show="!loading">
      <template v-if="message">
        <CAlert color="danger" v-for="(item, i) in message" closeButton :key="i">
          {{ item }}
        </CAlert>
      </template>
      <CForm autocomplete="off" @submit.prevent="login" v-show="!isMFAAuthentication">
        <p class="mb-5 title-login">
          {{ $t('auth.login.header1.login') }}
        </p>

        <CRow :gutters="false" class="mb-2">
          <!-- <SocialLogin /> -->
          <!-- <router-link :to="{ name: 'NewRegister' }">Sing up</router-link> -->
        </CRow>
        <CRow>
          <CCol md="12">
            <div class="">
              <CInput
                type="email"
                id="email"
                maxlength="255"
                addLabelClasses="mb-0"
                autocomplete="email"
                :label="$t('auth.login.input.email')"
                :lazy="false"
                :value.sync="$v.user.email.$model"
                :isValid="checkIfValid('email')"
                :invalidFeedback="$t('auth.login.input.validation-email')"
              />
            </div>
          </CCol>
          <CCol md="12 mt-3">
            <div class="form-group">
              <CInput
                type="password"
                id="password"
                autocomplete="off"
                maxlength="255"
                addLabelClasses="mb-0"
                :label="$t('auth.login.input.password')"
                :lazy="false"
                :value.sync="$v.user.password.$model"
                :isValid="checkIfValid('password')"
                :invalidFeedback="$t('auth.login.input.validation-password')"
              />
            </div>
          </CCol>
          <CCol sm="12" class="mb-1">
            <div class="form-inline">
              <CLink class="mx-2 text-recovery" :to="{ name: 'recovery' }">
                {{ $t('auth.login.link.forgotPassword') }}
              </CLink>
            </div>
          </CCol>
          <CCol sm="12" md="5">
            <CButton :disabled="!isValid || submitted" type="submit" class="btn btn-block font-weight-bold font-2xl mt-5 btn-arpoone">
              {{ $t('auth.login.button.signIn') }}
            </CButton>
          </CCol>
          <CCol sm="12" md="12" class="mt-5">
            <span v-if="!this.$store.getters['whitelabel/isWhitelabel']">
              <a
                v-if="currentLang == 'en-US'"
                class="send-email"
                href="https://webforms.pipedrive.com/f/1CaPSuJX0l71HIYKpLucSr30ar5HEY2AeNB3vUtFzRTqpOEWf4wAkE3kzoxSWhFlx"
                >{{ $t('auth.login.email-send.text') }}</a
              >
              <a
                v-if="currentLang == 'pt-PT'"
                class="send-email"
                href="https://webforms.pipedrive.com/f/1GbaXk4QEepQVsLDlzRlToCUfOJH8ga2q600ImR9eAk1uFDu6OGv3AQGVH9eBJFwD"
                >{{ $t('auth.login.email-send.text') }}</a
              >
              <span v-if="canRegister" class="mx-3">{{ $t('auth.login.or') }}</span>
            </span>
            <CButton
              v-if="!this.$store.getters['whitelabel/isWhitelabel'] && canRegister"
              @click="$router.push({ name: 'NewRegister' })"
              color="primary"
              variant="outline"
            >
              {{ $t('auth.login.signUp') }}
            </CButton>
          </CCol>
        </CRow>
      </CForm>
      <div v-if="isMFAAuthentication">
        <div>
          <p class="mb-5 title-login">
            {{ $t('auth.login.header.mfa') }}
          </p>
        </div>
        <transition name="fade">
          <MensageAlert :messages="successMessage" />
        </transition>
        <div>
          <MFAForm
            :userId="mfa.userId"
            @cancelConfirmation="closeMFAAuthentication()"
            @confirmMFAValidation="confirmMFAValidation()"
            @showMessage="showMessage"
            @showSuccess="showSuccess"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import services from '@/services'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'
import MFAForm from '../components/login/MFAForm.vue'
import MensageAlert from '@/components/MenssageAlert'
import { featuresEnum, checkFeatures } from '@/utils/featureUtils'

// import SocialLogin from '../components/SocialLogin'
export default {
  name: 'Login',
  components: {
    // SocialLogin,
    MFAForm,
    MensageAlert,
  },
  data() {
    return {
      canRegister: true,
      isMFAAuthentication: false,
      message: [],
      successMessage: [],
      submitted: false,
      mfa: {
        userId: null,
      },
      user: {
        email: '',
        password: '',
      },
      loading: false,
    }
  },
  mixins: [validationMixin],
  validations: {
    user: {
      email: {
        required,
        email,
        maxLength: maxLength(255),
      },
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(255),
      },
    },
  },
  methods: {
    showSuccess(message) {
      this.successMessage = []
      this.successMessage.push(message)
    },
    showMessage(message) {
      this.message = []
      this.message.push(message)
    },
    showMFAAuthenticacation(userId) {
      this.mfa.userId = userId
      this.isMFAAuthentication = true
    },
    closeMFAAuthentication() {
      this.isMFAAuthentication = false
      this.mfa.userId = null
    },
    checkIfValid(fieldName) {
      const field = this.$v.user[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },
    selectOrganization() {
      // Verifica se o utilizador possui mais de uma organization
      services
        .getUserOrganizations(this.$store.state.auth.user.id, true, 1, 10)
        .then((res) => {
          let list = res.data.data.items

          if (Array.isArray(list)) {
            let isRedirect = this.$route.query.so

            if (isRedirect) {
              let organization = list.find((el) => el.organizationId === isRedirect)
              if (organization) {
                if (this.$route.query.page) {
                  this.$store.dispatch('auth/selectOrganization', { value: isRedirect }).then(() => {
                    this.$router.push({ name: this.$route.query.page, params: { organizationId: isRedirect } })
                  })
                } else {
                  this.$store.dispatch('auth/selectOrganization', { value: isRedirect }).then(() => {
                    this.$router.push({ name: 'home', params: { organizationId: isRedirect } })
                  })
                }
                return
              } else {
                this.$store.dispatch('auth/logout', false)

                this.message.push(this.$t('auth.login.message.errorOrganizationSelected'))
                return
              }
            }

            // Caso possua apenas uma organização, redireciona para home
            if (list.length === 1) {
              this.$store.dispatch('auth/selectOrganization', { value: list[0].organizationId }).then(() => {
                this.$router.push({ name: 'load', params: { organizationId: list[0].organizationId }, query: { next: 'home' } })
                // this.$router.push({ name: 'home', params: { organizationId: list[0].organizationId } })
              })

              // Caso possua mais de uma organização ou nenhuma, redireciona para ecrã de seleção de organização
            } else {
              if (list.length === 0) {
                this.$router.push({ name: 'NoOrganization' })
              } else {
                this.$router.push({ name: 'load', query: { next: 'OrganizationSelection' } })
                // this.$router.push({ name: 'OrganizationSelection' })
              }
            }
          }
        })
        .catch(() => {})
        .finally(() => setTimeout(() => (this.loading = false), 2000))
    },
    confirmMFAValidation() {
      this.selectOrganization()
    },
    login() {
      if (!this.isValid) {
        return
      }
      this.loading = true
      this.message = []

      let email = this.user.email
      let password = this.user.password
      this.$store
        .dispatch('auth/login', {
          email,
          password,
        })
        .then(async (response) => {
          if (!response) {
            return
          }

          if (this.$route.name === 'LoginWithInvite') {
            await services.acceptInvite(this.$route.params.inviteId)
          }

          this.selectOrganization()
        })
        .catch((err) => {
          let message = null
          const errorCode = err.errorCode || err.response.data.errorCode

          switch (errorCode) {
            case 6031:
              if (Array.isArray(err.errorParameters)) {
                if (err.errorParameters.length > 0) {
                  try {
                    let errorData = JSON.parse(err.errorParameters[0])
                    this.$store.commit('auth/UPDATE_REGISTER_STEP', errorData)
                    this.$router.push({ name: 'BusinessProfile' })
                    return
                  } catch (error) {
                    // TODO tratar
                  }
                } else {
                  message = err.message
                }
              } else {
                message = err.message
              }
              this.message.push(message)
              break
            case 10033:
              if (Array.isArray(err.errorParameters)) {
                if (err.errorParameters.length > 0) {
                  try {
                    let errorData = JSON.parse(err.errorParameters[0])
                    this.$store.commit('auth/UPDATE_REGISTER_STEP', errorData)
                    this.$router.push({ name: 'ConfirmRegister' })
                    return
                  } catch (error) {
                    // TODO tratar
                  }
                } else {
                  message = err.message
                }
              } else {
                message = err.message
              }
              this.message.push(message)
              break
            case 10034:
              if (Array.isArray(err.errorParameters)) {
                if (err.errorParameters.length > 0) {
                  try {
                    let errorData = err.errorParameters[0]
                    this.$router.push({ name: 'Userdisabled', params: { userId: errorData } })
                    return
                  } catch (error) {
                    // TODO tratar
                  }
                } else {
                  message = err.message
                }
              } else {
                message = err.message
              }
              this.message.push(message)
              break
            case 2101300: // MFA_REQUIRES_TWO_FACTOR_AUTH
              this.showMFAAuthenticacation(err.data.id)
              break
            case 108003:
              message = this.$t(`general.errors.${err.response.data.message}`)
              this.message.push(message)
              break
            case 10047: // PASSWORD_EXPIRED
              this.$router.push({
                name: 'newPasswordRecovery',
                // params: { token: err.data.passwordResetToken, id: err.data.id }, // REMOVIDO e passado via query
                query: { token: err.data.passwordResetToken, id: err.data.id, expired: 1 },
              })
              break
            default:
              message = err.message
              this.message.push(message)
              break
          }
        })
        .finally(() => setTimeout(() => (this.loading = false), 2000))
    },
  },
  computed: {
    isValid() {
      return !this.$v.user.$invalid
    },
    status() {
      return this.$store.getters['auth/authStatus']
    },
    currentLang() {
      return this.$store.state.lang
    },
  },
  mounted() {
    checkFeatures(featuresEnum.ACCOUNT_REGISTER).then((result) => (this.canRegister = result))
    this.$store.commit('auth/DEFAULT_AUTH_STATE')
    if (this.$route.query.lang) {
      switch (this.$route.query.lang) {
        case 'en':
          this.$root.$emit('chooseLang', 'en-US')
          break
        case 'pt':
          this.$root.$emit('chooseLang', 'pt-PT')
          break
        default:
          break
      }
    }
  },
}
</script>
<style lang="scss">
.title-login {
  font-family: 'Nunito Sans';
  color: #0f0f0f;
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
}

.form-group label {
  padding-bottom: 10px;
  font-family: 'Nunito Sans';
  color: #0f0f0f;
  font-style: normal;
}

.text-recovery {
  color: #888888;
  text-decoration: underline !important;
}

.btn-arpoone {
  background-color: #ceff00;
  color: #0f0f0f;
  font-size: 18px !important;
  padding-top: 15px;
  padding-bottom: 15px;
}

.btn-arpoone:hover {
  background-color: #ceff00;
  color: #0f0f0f;
  opacity: 0.8;
}
.btn-arpoone:active {
  background-color: #ceff00 !important;
  color: #0f0f0f !important;
}
.send-email {
  color: #8b65b3;
  text-decoration: underline !important;
}

.send-email:hover {
  color: #8b65b3;
}
</style>
